/**
 * Remove empty p tags accidentally placed by wordpress editor
 */
export default function initSmoothScrollLinks(){
    const links = document.querySelectorAll('a[href^="#"]:not([href="#"])');

    links.forEach(link => {
        link.addEventListener('click', function(e){
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if(targetElement){
                e.preventDefault();
                targetElement.scrollIntoView({behavior: 'smooth'});
            }
        });
    });
}